import { j as e } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as s, useRef as a, useContext as m } from "react";
import l from "../../Table.module.scss.js";
import { clsx as n } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import { TableContext as i } from "../../Context/Table.js";
import d from "../TableLoader/TableLoader.js";
const c = ({ children: t }) => {
  const o = a(null), { loading: r } = m(i);
  return /* @__PURE__ */ e.jsxs(
    "thead",
    {
      ref: o,
      className: "sticky top-0 z-10",
      children: [
        t,
        r && /* @__PURE__ */ e.jsx("tr", { className: n(l.tableLoader, "bottom-[2px]"), children: /* @__PURE__ */ e.jsx(d, { loading: !0 }) })
      ]
    }
  );
}, h = s(c);
export {
  h as default
};
//# sourceMappingURL=TableHeader.js.map
